
export const products = {
  'product.categories': '产品类别',
  'explore.solutions': '探索我们全面的专业视听解决方案',
  'view.video': '查看产品概述视频',
  'AV Over IP': 'IP上的AV',
  'ReAX Control': 'ReAX控制',
  'Meeting Room Solutions': '会议室解决方案',
  'Converters/Scalers': '转换器/缩放器',
  'Audio Products': '音频产品',
  'HDMI Switchers': 'HDMI切换器',
  'IPBaseT': 'IPBaseT',
  'HDBaseT Products': 'HDBaseT产品',
  'Complete AV distribution solution with ultra-low latency': '具有超低延迟的完整AV分配解决方案',
  'Professional control system solutions': '专业控制系统解决方案',
  'Complete solutions for modern meeting spaces': '现代会议空间的完整解决方案',
  'Professional format conversion and scaling solutions': '专业格式转换和缩放解决方案',
  'Professional audio processing and playback solutions': '专业音频处理和播放解决方案',
  'Professional HDMI switching and distribution solutions': '专业HDMI切换和分配解决方案',
  'Advanced IP-based AV distribution platform': '先进的基于IP的AV分配平台',
  'Professional HDBaseT distribution solutions': '专业HDBaseT分配解决方案',
  'group.not.found': '未找到群组',
  'product.not.found': '未找到产品',
  'return.to.home': '返回首页',
  'back.to.product.group': '返回产品组',
  'overview': '概述',
  'full.description': '完整描述',
  'features': '功能',
  'specifications': '规格',
};
